<div class="logout">
	<main role="main" class="container-fluid">
		<div class="well centerMeta">
			<h2>Thank you for using Knowvation.</h2>
			<p class="lead">You may now close the browser or tab.</p>
		</div>
	</main>
</div>
